/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L6_Intro_P2Inputs */

const es_l6_intro_p2 = /** @type {(inputs: L6_Intro_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicación, calendario, cobros y comunicación con los clientes, todo en una sola herramienta pensada para que tu barco llene más semanas.`)
};

const gl_l6_intro_p2 = /** @type {(inputs: L6_Intro_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicación, calendario, cobros e comunicación cos clientes, todo nunha soa ferramenta pensada para que o teu barco encha máis semanas.`)
};

const en_l6_intro_p2 = /** @type {(inputs: L6_Intro_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing, calendar, payments and guest communication — all in one tool designed to fill more weeks on your boat.`)
};

/**
* | output |
* | --- |
* | "Listing, calendar, payments and guest communication — all in one tool designed to fill more weeks on your boat." |
*
* @param {L6_Intro_P2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l6_intro_p2 = /** @type {((inputs?: L6_Intro_P2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L6_Intro_P2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l6_intro_p2(inputs)
	if (locale === "en") return en_l6_intro_p2(inputs)
	return es_l6_intro_p2(inputs)
});